module.exports = __webpack_public_path__ + "static/media/13a-04_Tablas&camas-2013-27x176mm-oleo-sobre-revista-National-Geographic-y-madera.0708d237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13a/13a-04_Tablas&camas-2013-27x176mm-oleo-sobre-revista-National-Geographic-y-madera.png
// module id = 129
// module chunks = 0